export default class TelLink {
  constructor(el){
    this.element = $(el);
    this.openClass = 'is-open';
    this.event();
  }

  event(){
    this.element.on('click', e => {
      if(KUWAHARA.device.device === 'pc'){
        e.preventDefault();
      }
    });
  }
}




// WEBPACK FOOTER //
// ./js/_modules/_telLink.js